import { useMemo } from 'react';
import { useGetStationByCode } from 'store/features/stations/selectors/stations';

import { Station } from 'dataSources/Typicode/stations/types/station';

import { getStationIconSettings } from 'common/utils/index';

export const useStationIcon = (stationCode: Station['code']) => {
  const getStationByCode = useGetStationByCode();

  const stationIcon = useMemo(() => {
    const { categoryCode, roadsideServiceCodes = [] } = getStationByCode(stationCode) || {};
    const { icon, iconColor = ''} = getStationIconSettings(categoryCode as number, roadsideServiceCodes);

    return { icon, iconColor };
  }, [stationCode, getStationByCode]);

  return stationIcon;
};
